<template>
    <div class="ms-style4" v-if="isShow">
        <div class="four">
            <img :src="imgMap1.adImgUrl" v-if="imgMap1&&imgMap1.id" @click="toLink(imgMap1)" class="mst-img1">
            <div class="four-btm">
                <img :src="imgMap2.adImgUrl" v-if="imgMap2&&imgMap2.id" @click="toLink(imgMap2)" class="mst-img2">
                <img :src="imgMap3.adImgUrl" v-if="imgMap3&&imgMap3.id" @click="toLink(imgMap3)" class="mst-img3">
            </div>
        </div>
    </div>
</template>

<script>
    import {getDeptId} from "../../../utils/auth";

    export default {
        data() {
            return {
                deptId: '',
                imgMap1: {},
                imgMap2: {},
                imgMap3: {},
                isShow:false,
            };
        },
        props: {
            imgMap: Object
        },
        async created() {
            if (this.imgMap.one) {
                this.imgMap1 = this.imgMap.one
                this.isShow=true
            }
            if (this.imgMap.two) {
                this.imgMap2 = this.imgMap.two
                this.isShow=true
            }
            if (this.imgMap.three) {
                this.imgMap3 = this.imgMap.three
                this.isShow=true
            }
            this.deptId = getDeptId()
            // this.getSpmMscList()
        },

        methods: {
            async getSpmMscList() {
                let data = {
                    deptId: this.deptId,
                    isShow: "0",
                }
                let res = await this.$get("/spm/getSpmMscList", data)
                this.msList = res.list
            },
            toLink(item) {
                if (item.adLink) {
                    this.$router.push(item.adLink)
                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    .ms-style4 {
        margin-bottom: 15px;
    }
    .four {
        display: flex;
        flex-direction: column;
        justify-items: center;
        justify-content: center;
        align-items: center;
    }

    .mst-img1 {
        width: 100%;
    }

    .four-btm {
        width: 92%;
        margin-top: -55px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .mst-img2 {
        width: 47%;
    }
    .mst-img3 {
        width: 47%;
    }
</style>
